export default __webpack_public_path__ + "static/media/soundPack2.c002cc6d.png";